import type { FileUploadWithDeckData, PDFImage } from "../constants/GlobalTypesAndEnumsAndConstants";

export function updatePdfImageInGenerationDocuments(
  documents: FileUploadWithDeckData[] | null,
  currentDocumentIndex: number | null,
  updatedImage: PDFImage
): FileUploadWithDeckData[] | null {
  if (!documents) return null;

  const resolvedDocumentIndex = currentDocumentIndex ?? 0;
  const currentDocument = documents[resolvedDocumentIndex];
  const currentDeck = currentDocument?.associatedDeck;
  if (!currentDeck?.generation_metadata) return documents;

  let imageWasUpdated = false;
  const updatedImages = (currentDeck.generation_metadata.pdf_images_object_list || []).map((image) => {
    if (image.imageUrl !== updatedImage.imageUrl) return image;
    imageWasUpdated = true;
    return updatedImage;
  });
  if (!imageWasUpdated) updatedImages.push(updatedImage);

  return documents.map((document, documentIndex) => {
    if (documentIndex !== resolvedDocumentIndex) return document;
    return {
      ...document,
      associatedDeck: {
        ...currentDeck,
        generation_metadata: {
          ...currentDeck.generation_metadata,
          pdf_images_object_list: updatedImages,
        },
      },
    };
  });
}

export function removePdfImageFromGenerationDocuments(
  documents: FileUploadWithDeckData[] | null,
  currentDocumentIndex: number | null,
  removedImageUrl: string
): FileUploadWithDeckData[] | null {
  if (!documents) return null;

  const resolvedDocumentIndex = currentDocumentIndex ?? 0;
  const currentDocument = documents[resolvedDocumentIndex];
  const currentDeck = currentDocument?.associatedDeck;
  if (!currentDeck?.generation_metadata) return documents;

  const currentImages = currentDeck.generation_metadata.pdf_images_object_list || [];
  const remainingImages = currentImages.filter((image) => image.imageUrl !== removedImageUrl);
  if (remainingImages.length === currentImages.length) return documents;

  return documents.map((document, documentIndex) => {
    if (documentIndex !== resolvedDocumentIndex) return document;
    return {
      ...document,
      associatedDeck: {
        ...currentDeck,
        generation_metadata: {
          ...currentDeck.generation_metadata,
          pdf_images_object_list: remainingImages,
        },
      },
    };
  });
}
